import { escapeHtml, qs } from '../dom.js';

export async function renderConfirmed(container: HTMLElement, sessionId: string): Promise<void> {
  const div = document.createElement('div');
  div.className = 'screen';
  div.innerHTML = `
    <div class="topbar"><h1>Confirmed</h1></div>
    <div class="card center">
      <p style="font-size:2.5rem;">✓</p>
      <p><strong>Receiving confirmed.</strong></p>
      <p class="hint">Quantities are locked and the Mintsoft update has been queued. It'll show up on the ASN list once processed — any further correction needs an Adjustment, not more scanning.</p>
      <p class="hint">Session: ${escapeHtml(sessionId)}</p>
    </div>
    <button class="primary" id="backBtn">Back to ASN List</button>
  `;
  container.appendChild(div);
  qs<HTMLButtonElement>(div, '#backBtn').addEventListener('click', () => {
    location.hash = '#/asns';
  });
}
